<div class="col-lg-12 bg-white border-bottom w-100" style="position:fixed; margin-bottom: 150px;z-index: 1000; top: 0;">
  <nav class="navbar navbar-expand-lg px-2 px-lg-0">
    <div class="container-fluid">
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <a (click)="GotoMydashboard()" style="cursor: pointer;">
        <img src="assets/img/portugal-mls-logo.png" alt="" class="h-50px logo" width="210px" height="50px">
      </a>

      <div class="collapse navbar-collapse nav-item-wrapper" id="navbarSupportedContent">
        <ul class="navbar-nav me-auto mb-2 mb-lg-0 ms-lg-4" (click)="onNavItemClick($event)">
          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" routerLink="/dashboard"
            routerLinkActive="active">
            <a style="cursor:pointer" class="nav-link fw-semibold">
              {{"Home" | translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper d-none" id="nav-btn-mobile-view" routerLink="/search"
            routerLinkActive="active">
            <a style="cursor: pointer;" class="nav-link fw-semibold">
              {{"Search"|translate}}
            </a>
          </li>

          <li class="nav-item dropdown nav-item-wrapper" routerLinkActive="active">
            <a style="cursor:pointer" class="nav-link dropdown-toggle fw-semibold" id="navbarDropdown1" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{'Search'|translate}}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown1">
              <li class="nav-item dropdown" id="nav-btn-mobile-view">
                <a style="cursor:pointer;" class="dropdown-item fw-semibold" routerLink="/search">{{'SearchListings' |
                  translate}}
                </a>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li class="nav-item dropdown" id="nav-btn-mobile-view">
                <a style="cursor:pointer;" class="dropdown-item fw-semibold"
                  routerLink="/saved-search">{{'SavedSearches' | translate}}</a>
              </li>
            </ul>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" routerLink="/contact" routerLinkActive="active"
            (click)=" GotoContacts()" *ngIf="roleId == 4 || roleId == 6">
            <a style="cursor:pointer" class="nav-link fw-semibold">
              {{'Contacts'|translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" [routerLink]="['admins']"
            routerLinkActive="active" *ngIf="roleId == 2 || roleId == 1">
            <a class="nav-link fw-semibold">
              {{"Membership" | translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" [routerLink]="['office-manager']"
            routerLinkActive="active" *ngIf="roleId == 4">
            <a class="nav-link fw-semibold">
              {{"Membership" | translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" [routerLink]="['company-offices']"
            routerLinkActive="active" *ngIf="roleId == 3">
            <a class="nav-link fw-semibold">
              {{"Membership" | translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" [routerLink]="['agent']"
            routerLinkActive="active" *ngIf="roleId == 5">
            <a class="nav-link fw-semibold">
              {{"Membership" | translate}}
            </a>
          </li>

          <li class="nav-item nav-item-wrapper" id="nav-btn-mobile-view" routerLink="/tours" routerLinkActive="active"
            *ngIf="roleId <=6">
            <a class="nav-link fw-semibold">
              {{"Tours" | translate}}
            </a>
          </li>

          <li class="nav-item dropdown nav-item-wrapper " routerLinkActive="active">
            <a style="cursor:pointer" class="nav-link dropdown-toggle fw-semibold" id="navbarDropdown" role="button"
              data-bs-toggle="dropdown" aria-expanded="false">
              {{'Listing'|translate}}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
              <li class="nav-item dropdown" id="nav-btn-mobile-view">
                <a class="dropdown-item fw-semibold"
                  [ngStyle]="{'cursor': isAddListingMenuDisabled ? 'not-allowed' : 'pointer'}"
                  [routerLink]="isAddListingMenuDisabled ? null : '/add-listing'">{{'AddListing'|translate}}</a>
              </li>

              <!-- Conditionally display <hr> if both list items are present -->
              <li *ngIf="roleId == 4 || roleId == 5 || roleId == 6 && isAddListingMenuDisabled === false">
                <hr class="dropdown-divider">
              </li>

              <li class="nav-item dropdown" id="nav-btn-mobile-view" *ngIf="roleId == 4 || roleId == 5 || roleId == 6">
                <a style="cursor:pointer;" class="dropdown-item fw-semibold"
                  routerLink="/my-listings">{{'MyListings'|translate}}</a>
              </li>
            </ul>
          </li>

          <li class="nav-item dropdown nav-item-wrapper guide-dropdown" routerLinkActive="active">
            <a style="cursor: pointer" class="nav-link dropdown-toggle fw-semibold"
              [ngClass]="{'no-arrow': !hasGuideAdmin}" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
              routerLink="/guide" aria-expanded="false">
              {{ 'Guide' | translate }}
            </a>
            <ul class="dropdown-menu" aria-labelledby="navbarDropdown" *ngIf="roleId < 4">
              <li class="nav-item dropdown">
                <a class="dropdown-item fw-semibold"
                  [ngStyle]="{'cursor': isAddListingMenuDisabled ? 'not-allowed' : 'pointer'}"
                  [routerLink]="isAddListingMenuDisabled ? null : '/guide-admin'">
                  {{ 'GuideEditor' | translate }}
                </a>
              </li>
            </ul>
          </li>

        </ul>

        <div class="d-none d-lg-block">
          <div class="d-flex align-items-center">
            <div class="dropdown language-dropdown">
              <button class="btn btn-secondary dropdown-toggle p-0" id="dropdownMenuLink" data-bs-toggle="dropdown"
                aria-expanded="false">
                <img [src]="currentLanguage.icon" class="flag-img" [alt]="currentLanguage.name" height="22" width="29">
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                <li *ngFor="let language of languages">
                  <a class="dropdown-item" (click)="changeLanguage(language)">
                    <img [src]="language.icon" height="18" width="21">
                  </a>
                </li>
              </ul>
            </div>

            <div class="d-flex d-grid gap-3">
              <form class="d-flex d-grid gap-3 justify-content-between align-items-center" role="search">
                <i type="button" style="font-size: 28px; height: 25px;">
                  <mat-icon type="button" class="colornavy screen" *ngIf="!features.isFullScreenRequested"
                    (click)="openFullscreen()">fullscreen</mat-icon>
                  <mat-icon type="button" class="colornavy screen icon_color" *ngIf="features.isFullScreenRequested"
                    (click)="closeFullscreen()">fullscreen_exit</mat-icon>
                </i>
                <div>
                  <img *ngIf="loggedUser" class="fw-bold colornavy pt-3 d-flex d-grid gap-3 fs-6"
                    style="cursor: pointer;" (click)="this.Userprofile()"
                    src="https://cdn-icons-png.flaticon.com/128/1177/1177568.png" class="userprofile">
                </div>
              </form>
            </div>
            <i type="button" class="btn btn-primary" style="font-size: 23px;" data-bs-toggle="modal"
              data-bs-target="#exampleModal" class="fa fa-sign-out fa-lg icon_color ps-3 me-xl-4"></i>
          </div>
        </div>
      </div>

      <div class="d-lg-none mobile-view-icons">
        <div class="d-flex align-items-center">
          <div class="dropdown language-dropdown">
            <button class="btn btn-secondary dropdown-toggle p-0" id="dropdownMenuLink" data-bs-toggle="dropdown"
              aria-expanded="false">
              <img [src]="currentLanguage.icon" class="flag-img" [alt]="currentLanguage.name" height="20" width="27">
            </button>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <li *ngFor="let language of languages">
                <a class="dropdown-item" (click)="changeLanguage(language)">
                  <img [src]="language.icon" height="18" width="21">
                </a>
              </li>
            </ul>
          </div>

          <div class="d-flex d-grid gap-3">
            <form class="d-flex d-grid gap-3 justify-content-between align-items-center" role="search">
              <i type="button" style="font-size: 28px; height: 25px;">
                <mat-icon type="button" class="colornavy screen" *ngIf="!features.isFullScreenRequested"
                  (click)="openFullscreen()">fullscreen</mat-icon>
                <mat-icon type="button" class="colornavy screen icon_color" *ngIf="features.isFullScreenRequested"
                  (click)="closeFullscreen()">fullscreen_exit</mat-icon>
              </i>
              <div>
                <img *ngIf="loggedUser" class="fw-bold colornavy pt-3 d-flex d-grid gap-3 fs-6" style="cursor: pointer;"
                  (click)="this.Userprofile()" src="https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
                  class="userprofile">
              </div>
            </form>
          </div>
          <i type="button" class="btn btn-primary" style="font-size: 23px;" data-bs-toggle="modal"
            data-bs-target="#exampleModal" class="fa fa-sign-out fa-lg icon_color ps-3"></i>
        </div>
      </div>
    </div>
  </nav>
</div>


<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered model-lg">
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="text-center">
              <img src="assets/img/icon-1.png" class="img-fluid logout-img" alt="">
            </div>
            <div class="text-center">
              <p class="logout-text mb-5"> {{'AreyousurewanttoLogout'|translate}}</p>
            </div>
          </div>
          <div class="col-md-6 mb-3">
            <button type="button" class="btn rounded-pill btn continue-btn w-100 py-2"
              data-bs-dismiss="modal">{{'Close'|translate}}</button>
          </div>
          <div class="col-md-6 mb-3">
            <button type="button" class="btn rounded-pill btn save-btn w-100 py-2"
              (click)="LogoutUser()">{{'Logout'|translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
